export default __webpack_public_path__ + "static/media/Swiss Liquid-update-1.a8a7fc97.png";